export default "__VITE_ASSET__5b1609bf__"